module.exports = __webpack_public_path__ + "img/trax-2022.688f686d.png";